export const cityRank = [
	{ cityName: 'Delhi', rank: 1 },
	{ cityName: 'Herat', rank: 2 },
	{ cityName: 'Lucknow', rank: 3 },
	{ cityName: 'Isfahan', rank: 4 },
	{ cityName: 'Tehran', rank: 5 },
	{ cityName: 'Bukhara', rank: 6 },
	{ cityName: 'Bhopal', rank: 7 },
	{ cityName: 'Arcot', rank: 8 },
	{ cityName: 'Hyderabad', rank: 9 },
];
